import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  deleteFavoritePairing,
  type DeleteFavoritePairingParams,
} from '@hungryroot/rest/api/v2/customers/[id]/favorite_pairings/[pairing_id]/delete/delete-favorite-pairing';
import { invalidateFavoritePairings } from './useFavoritePairings';

export function useDeleteFavoritePairing() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (queryParams: DeleteFavoritePairingParams) => {
      const res = await deleteFavoritePairing(queryParams);

      if (res.status !== StatusCode.SuccessNoContent) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess: () => {
      invalidateFavoritePairings(queryClient);
    },
  });
}
